(function (app) {
    app.component("timelineEventNoteComponent",
        {
            templateUrl:
            "/App/Client/Activity/TimelineEventClientNoteComponent/timeline-event-client-note-component.html",
            controller: timelineEventNoteComponentController,
            bindings: {
                event: "<",
                currentUser: "<",
                onDeleteNote: "&",
                onUpdateNote: "&"
            }
        });
    function timelineEventNoteComponentController() {
        var $ctrl = this;

        $ctrl.$onInit = () => {
            $ctrl.editMode = false;
            $ctrl.model = {
                content: $ctrl.event.Description
            };
        }

        $ctrl.cancelEdit = function() {
            $ctrl.model.content = $ctrl.event.Description;
            $ctrl.editMode = false;
        }

        $ctrl.updateNote = function ($event) {
            if ($ctrl.model.content) {
                $ctrl.onUpdateNote({ content: $ctrl.model.content, $event: $event });
                $ctrl.editMode = false;
            }
        }

    };
})(window.app); //jshint ignore:line